import { render, staticRenderFns } from "./InitialSettingsComponent.vue?vue&type=template&id=2eb18fd4"
import script from "./InitialSettingsComponent.vue?vue&type=script&lang=ts"
export * from "./InitialSettingsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports